// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1___b04ae05ad89e67dfe8f","cls2":"ConfirmationModal-cls2___bea254a813abedd60b6 ConfirmationModal-cls1___b04ae05ad89e67dfe8f"};